import View from '../view';
import './index_mWeb.css';
import avatars from '../../constants/avatars';
import useWindowOrientation from '../../utilities/hooks/useWindowOrientation';
import React from 'react';
import Constants from '../../constants';
import Text from '../text';
import { setIsDrawerOpen } from '../../actions/user-actions-types';
import { useDispatch, useSelector } from 'react-redux';

const HeaderMWeb = ({
  isWelcomeMessage,
  xpCoinContainerStyle,
  logInBtnStyle,
  signUpBtnStyle,
  teamName,
  avatarId,
  balance,
  xpPoints,
  openLogInModal,
  openSignUpModal
}: any) => {
  const { isDrawerOpen = false } = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const { isLandscape } = useWindowOrientation();
  const onClickProfile = () => {
    if (teamName) {
      dispatch(setIsDrawerOpen(!isDrawerOpen));
    }
  };
  return (
    <View className={`header_wrapper_mWeb ${isLandscape ? 'header__landscape__wrappper' : ''}`}>
      <div className="header_user_welcome_mWeb">
        <img src={avatars[avatarId]} className="header_user_avatar_mWeb" onClick={onClickProfile} />
        {isWelcomeMessage && <p>{`${teamName}`}</p>}
      </div>
      <div className="header_user_info_wrapper_mWeb">
        <div className="utility__area__mWeb">
          {!teamName && (
            <React.Fragment>
              <button
                className="header__login__signUp__btn__mWeb"
                style={logInBtnStyle}
                onClick={openLogInModal}>
                Log In
              </button>
              <button
                className="header__login__signUp__btn__mWeb"
                style={signUpBtnStyle}
                onClick={openSignUpModal}>
                Sign Up
              </button>
            </React.Fragment>
          )}
          {teamName && (
            <React.Fragment>
              <div className="header__coin__container__mWeb" style={xpCoinContainerStyle}>
                <img src={Constants.Images.xp} width={30} />
                <Text className="header__xp__coins__txt__mWeb">{xpPoints}</Text>
              </div>
              <div className="header__xp__container__mWeb" style={xpCoinContainerStyle}>
                <img className="header__Coins__img__mWeb" src={Constants.Images.coin} />
                <Text className="header__xp__coins__txt__mWeb">{balance['totalBalance']}</Text>
                <img
                  className="header__addCashPlus__img__mWeb"
                  src={Constants.Images.addCashPlus}
                  width={'15px'}
                />
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </View>
  );
};

export default HeaderMWeb;
